<template>
  <div>
    <!-- <PageHead title="审批任务到期提醒"></PageHead> -->
    <PageHead title="短信提醒"></PageHead>
    <div class="oa-layout-content">
      <!-- <div class="mb20">
        <a-button type="primary" @click="add" icon="plus"> 新建</a-button>
      </div> -->
      <a-table
        v-if="!loading"
        :pagination="false"
        :columns="columns"
        :data-source="data"
        childrenColumnName="treeList"
        rowKey="id"
        defaultExpandAllRows
        :loading="loading"
      >
        <span slot="flag" slot-scope="text, record">
          <!-- {{ text == 1 ? "部门" : "公司" }} -->
          <span v-if="text == 1">
            审批任务
            <!-- <a-input-number
              @focus="focusChange(record)"
              :min="0"
              class="w50 ml5 mr5"
              v-model="record.day"
            />天后未处理，发起短信提醒 -->
            <span
              @click="focusChange(record)"
              :min="0"
              class="w50 ml5 mr5 span-border"
            >
              {{ record.day }}
            </span>
            天后未处理，发起短信提醒
          </span>
        </span>
        <div slot="isenableNum" class="statusDiv" slot-scope="text, record">
          <a-switch
            v-if="record.flag == 1"
            :checked="text == 1"
            @click="onChange(record)"
            :loading="switchloading == record.id"
          />
        </div>
        <!-- <div slot="action" slot-scope="text, record">
          <a-button
            v-if="record.flag == 1"
            type="link"
            class="btn-link"
            @click="goDetial(record)"
          >
            确定
          </a-button>
        </div> -->
      </a-table>
    </div>
    <appfloor></appfloor>
    <!-- 更改日期弹窗 -->
    <a-modal v-model="smsAlertModel" title="短信提醒" @ok="handleSmsAlertOk">
      设置短信提醒（天）：
      <a-input-number id="inputNumber" v-model="smsalertNum.day" :min="1" />
    </a-modal>
  </div>
</template>
<script>
const columns = [
  {
    title: '组织机构名称',
    dataIndex: 'organizationName',
    key: 'organizationName',
    ellipsis: true
  },
  {
    title: '描述',
    dataIndex: 'flag',
    scopedSlots: { customRender: 'flag' },
    key: 'flag',
    ellipsis: true,
    align: 'center'
  },

  {
    title: '启用/禁用',
    dataIndex: 'isenableNum',
    scopedSlots: { customRender: 'isenableNum' },
    key: 'isenableNum',
    align: 'center'
  }
  // {
  //   scopedSlots: { customRender: 'action' },
  //   title: '操作',
  //   align: 'left',
  //   width: 120
  // }
]

import { smsTreeList, smsUpdateRoleEnableNumById } from './api/api'
export default {
  data() {
    return {
      expand: false,
      expandedKeys: [10010], //当前默认选中的机构 ，为了保证默认展开
      data: [],
      columns,
      switchloading: '',
      loading: true,
      smsAlertModel: false,
      smsalertNum: []
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      smsTreeList().then((res) => {
        this.data = res.data.data
        this.loading = false
      })
    },
    // 关闭 更改日期 弹窗
    handleSmsAlertOk() {
      let data = {
        organizationId: this.smsalertNum.id
      }
      if (this.smsalertNum.day) {
        data.day = parseInt(this.smsalertNum.day)
      } else {
        this.$message.error('请先输入天数！')
        return
      }
      smsUpdateRoleEnableNumById(data).then((res) => {
        if (res.data.code == 0) {
          this.$message.success('修改成功')
          this.smsAlertModel = false
        }
        this.load()
      })
    },
    // 更改日期
    focusChange(record) {
      this.smsAlertModel = true
      this.smsalertNum = record
    },
    // 禁用 启用
    onChange(checked) {
      if (checked.day === null) {
        this.$message.error('请先选择审批任务短信提醒时间')
      } else {
        //启用禁用
        this.switchloading = checked.id
        let data = {
          organizationId: checked.id
        }
        if (checked.isenableNum == 1) {
          data.isenableNum = 2
        } else {
          data.isenableNum = 1
        }
        smsUpdateRoleEnableNumById(data).then((res) => {
          this.switchloading = ''
          this.load()
          if (res.data.code == 0) {
            this.$message.success('修改成功')
          }
        })
      }
    },
    showDeleteConfirm() {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk() {},
        onCancel() {}
      })
    },
    add() {
      this.$router.push('/addInstitutionalFramework')
    }
  }
}
</script>
<style lang="scss" scoped>
.statusDiv {
  display: flex;
  align-items: center;
  justify-content: center;
}
.span-border {
  border: 1px solid #ebedf0;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/system/smsAlert.vue